<div class="execute-shell">
  <!-- Top bar + stepper stay pinned while the test content scrolls -->
  <div class="exec-sticky">
  <!-- Slim top bar (AC1) -->
  <header class="execute-topbar">
    <button class="back-link" type="button" (click)="back()">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        width="16"
        height="16"
      >
        <path d="m15 18-6-6 6-6" />
      </svg>
      Back
    </button>

    <!-- The release name moved onto the switcher chip beside it, so it isn't
         printed twice in a bar this slim (Bug 56801 / PBI 55102). -->
    <app-release-switcher />

    @if (context(); as c) {
      <div class="exec-breadcrumb">
        <span>{{ c.suiteName }}</span>
        <span class="sep">/</span>
        <span class="current">{{ c.planName }}</span>
      </div>
    }

    <div class="header-spacer"></div>

    <app-user-menu />
  </header>

  <!-- Progress strip — centered numbered stepper (AC2/AC3) -->
  @if (total() > 0) {
    <section class="exec-progress-strip">
      <div class="progress-text-row">
        <span class="strong">Test {{ currentIndex() + 1 }} of {{ total() }}</span>
      </div>
      <div class="stepper-row">
        <button
          class="step-nav-btn"
          type="button"
          aria-label="Previous test"
          [disabled]="!canPrev()"
          (click)="prev()"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <div class="step-bar">
          @for (node of stepperNodes(); track node.testCaseId; let i = $index) {
            @if (i > 0) {
              <div class="step-line {{ stepperNodes()[i - 1].status }}"></div>
            }
            <button
              class="step-node {{ node.status }}"
              type="button"
              [title]="'Test ' + node.num"
              (click)="goToTestCase(node.testCaseId)"
            >
              @if (node.status === 'passed') {
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              } @else if (node.status === 'failed') {
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M6 6l12 12M6 18L18 6" />
                </svg>
              } @else {
                {{ node.num }}
              }
            </button>
          }
        </div>
        <button
          class="step-nav-btn"
          type="button"
          aria-label="Next test"
          [disabled]="!canNext()"
          (click)="next()"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
    </section>
  }
  </div>

  <!-- Test case content -->
  <main class="exec-content">
    @if (workItem(); as wi) {
      <article class="test-card">
        @if (context(); as c) {
          <div class="test-eyebrow">{{ c.suiteName }} · {{ c.planName }}</div>
        }
        <h1 class="test-title">{{ wi.testCaseName }}</h1>

        @if (wi.description) {
          <div class="test-description markdown-body">
            <markdown [data]="wi.description"></markdown>
          </div>
        }

        @if (wi.steps) {
          <div class="steps-body markdown-body">
            <markdown [data]="wi.steps"></markdown>
          </div>
        }

        <!-- Comments (PBI 57768): outside the steps @if so it shows with no steps too. -->
        <app-comment-thread [testCaseId]="currentTestCaseId()" />
      </article>

      <!-- Pass / Fail / Skip actions (AC6) -->
      <div class="exec-actions">
        <div class="action-row">
          <button
            class="btn btn-pass btn-lg"
            type="button"
            [disabled]="isSaving()"
            (click)="pass()"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              width="18"
              height="18"
            >
              <path d="M5 12l5 5L20 7" />
            </svg>
            It passed
          </button>
          <button
            class="btn btn-fail btn-lg"
            type="button"
            [disabled]="isSaving()"
            (click)="fail()"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
              width="18"
              height="18"
            >
              <path d="M6 6l12 12M6 18L18 6" />
            </svg>
            It failed
          </button>
          <button
            class="btn btn-skip btn-lg"
            type="button"
            [disabled]="isSaving()"
            (click)="skip()"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              width="18"
              height="18"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="13 17 18 12 13 7" />
              <polyline points="6 17 11 12 6 7" />
            </svg>
            Skip
          </button>
        </div>
      </div>
    } @else {
      <div class="exec-empty">Loading test case…</div>
    }
  </main>
</div>
